export default "__VITE_ASSET__CmicLX3z__"